import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { ErrorMessage } from '../../components/ErrorMessage';
import { changePassword } from '../../api/actions';
import ChangePasswordForm from './ChangePasswordForm';

import ROUTES from 'routes.json';
import { CardLayout } from '../../layouts/CardLayout/CardLayout';
import * as _ from 'lodash';
import PropTypes from 'prop-types';
import { formStates } from './formStates';

export class ChangePassword extends Component {
  static propTypes = {
    resetToken: PropTypes.string,
    changePassword: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      formState: formStates.INITIAL,
      errors: {
        changePassword: '',
      },
    };
  }

  render() {
    if (this.isFormInInvalidTokenState()) {
      return this.redirectToResetPasswordWithError();
    } else if (this.isFormInPasswordUpdatedState()) {
      return this.redirectToProductPageWithSuccess();
    }

    return (
      <div data-test-page-name="ChangePassword">
        <CardLayout>
          <p>
            Enter new password. Password must be at least 8&nbsp;characters long and must contain at least one uppercase
            character, lowercase character, number, and symbol
          </p>
          {this.renderErrorIfNecessary()}
          {this.renderForm()}
        </CardLayout>
      </div>
    );
  }

  renderForm() {
    return (
      <ChangePasswordForm
        resetToken={this.props.resetToken}
        isLoading={this.isLoading()}
        onChange={formState => this.changeFormState(formState)}
        onError={error => this.setPasswordError(error)}
        changePassword={this.props.changePassword}
      />
    );
  }

  renderErrorIfNecessary() {
    return (
      this.state.errors.changePassword && (
        <ErrorMessage data-test-error-message error message={this.state.errors.changePassword} />
      )
    );
  }

  redirectToProductPageWithSuccess = () => {
    return (
      <Redirect
        exact
        to={{
          pathname: ROUTES.PRODUCT,
          state: {
            passwordChanged: true,
          },
        }}
      />
    );
  };

  redirectToResetPasswordWithError = () => {
    return (
      <Redirect
        exact
        to={{
          pathname: ROUTES.RESET_PASSWORD,
          state: {
            invalidResetPasswordToken: true,
          },
        }}
      />
    );
  };

  isLoading() {
    return this.state.formState === formStates.LOADING;
  }

  changeFormState(formState) {
    this.setState({ formState });
  }

  setPasswordError(error) {
    this.setState({
      errors: {
        changePassword: error,
      },
    });
  }

  isFormInMissingTokenState() {
    return this.state.formState === formStates.MISSING_TOKEN;
  }

  isFormInInvalidTokenState() {
    return this.state.formState === formStates.INVALID_TOKEN;
  }

  isFormInPasswordUpdatedState() {
    return this.state.formState === formStates.PASSWORD_UPDATED;
  }
}

const ChangePasswordWithResetToken = props => {
  const resetToken = _.get(props, 'match.params.token');
  if (!resetToken) {
    return <Redirect to={ROUTES.RESET_PASSWORD} />;
  }
  return <ChangePassword resetToken={resetToken} changePassword={changePassword} />;
};

export default withRouter(ChangePasswordWithResetToken);
